<template>
	<div>
		<SupportBanner />
		<div class="content-zsy" v-loading="loading" style="min-height: 400px;">
			<div class="title-wrap">
				<h3>공지사항</h3>
				<h4>고로켓고의 공지사항을 확인하세요.</h4>
			</div>
			
			<el-row class="list-top">
				<el-col :xs="24" :sm="12">
					<h4>
						공지사항	<span>{{total}}개</span>
					</h4>
				</el-col>
				<el-col :xs="24" :sm="12">
					<el-input v-model="search" class="search" @change="changeSearch" placeholder="검색어를 입력해주세요."></el-input>
				</el-col>
			</el-row>
			  <el-table v-if="!isMobile"
			    :data="tableData" empty-text="데이터가 없습니다"
			    stripe @row-click="clickDetails"
			    style="width: 100%">
				<el-table-column
				  prop="nickname" 
				  label="게시자"
				  width="180">
				</el-table-column>
				<el-table-column
				  prop="title"
				  label="제목">
				</el-table-column>
			    <el-table-column
			      prop="createtime"
			      label="작성일"
			      width="180">
			    </el-table-column>
			  </el-table>
			  <el-table v-else
			    :data="tableData" empty-text="데이터가 없습니다"
			    stripe @row-click="clickDetails"
			    style="padding: 0 10px;width: 100%">		
					<el-table-column
					  prop="title"
					  label="제목">
					</el-table-column>
		
			  </el-table>
			  
				<div class="page">
					<el-pagination
						layout="prev, pager, next" :page-size="20"
						:total="total"  @current-change="handleCurrentChange">
					</el-pagination>
				</div>
			  
				<p class="text-center" style="margin-top: 50px">
					공지사항 미확인으로 인해  불이익이 발생하지 않도록 주의 당부를 부탁드립니다<br>
					이 경우 고로켓고의 책임이 없음을 안내드립니다
				</p>
		</div>

	</div>
</template>

<script>
	import SupportBanner from '../../components/SupportBanner.vue'
	import request from '@/utils/request'
	export default {
		components: {
			SupportBanner,
		},
		data() {
			return{
				total:0,
				page:1,
				
				search: '',
				tableData: [],
				loading: true,
			}
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			}
		},
		created() {
			this.getList()
		},
		methods: {
			clickDetails(row, column, event){
				console.log(row,1)
				console.log(column,1)
				console.log(event,3)
				
				this.$router.push(`/noticeDetails/${row.id}`)
				
			},
			getList(){
				this.loading = true
				console.log("加载列表功能")
				request.post('/Notice/getNoticeList',
					{
						search:this.search,
						page:this.page,
					}
				).then(res => {
					this.loading = false
					console.log(res,"列表")
					if(res.code ==1){
						this.total = res.data.total
						this.tableData= res.data.data//this.tableData.concat(res.data.data)
						
					}
						
				}).catch(() => {
					this.loading = false
				});
				
			},
			handleCurrentChange(val) {
			    console.log(`当前页: ${val}`);
				this.page = val
				this.getList()
			},
			changeSearch(value){
				console.log(value,333333333333)
				this.search = value
				
				this.page = 1
				this.getList()
			}
			
		}
	}
</script>

<style scoped>
	.title-wrap{
		text-align: center;
		color: var(--frontground-color);
		margin-bottom: 60px;
	}
	.title-wrap h3 {
	    font-size: 20px;
	    font-weight: bold;
	    color: var(--main-color);
	    margin: 0 0 19px;
	}
	.title-wrap h4 {
	    font-weight: 700;
	    font-size: 36px;
	    line-height: 1.34;
	    margin: 0;
	}
	.list-top{
		padding:10px;
	}
	.list-top h4 {
	    font-size: 30px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    padding: 0;
	    margin: 0;
	}
	.list-top h4 span {
	    color: var(--main-color);
	}
	.search{
		margin-left: 50%;
		width:50%;
	}
	.page{
		padding-top: 20px;
		text-align: center;
	}

	.text-center {
	    text-align: center !important;
	}
	/* 分页背景 */
	::v-deep .el-pager li {
		background-color: #121212;
	}
	::v-deep .el-pagination button:disabled {
		background-color: #121212;
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.title-wrap{
			margin-top: 20px;
		}
		.title-wrap h3 {
			font-size: 18px;
			color: #0055D4;
			font-weight: bold;
			line-height: 23px;
		}
		.title-wrap h4 {
			font-weight: 700;
			font-size: 30px;
			line-height: 39px;
			text-align: center;
		}
		.list-top h4 {
			text-align: center;
			padding-bottom: 10px;
		}
		.search{
			margin-left: 0;
			width:100%;
		}
		
	
	}
	
</style>